export default "__VITE_ASSET__cbb0a4cd__"